import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Attestation from "./tabs/Attestation";
import { Wrapper } from "../styled";

const attestationsTabs = [
  {
    title: "Аттестация",
    component: <Attestation/>,
  }
];

const Attestations: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {attestationsTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {attestationsTabs[tab].component}
    </Wrapper>
  );
};

export default Attestations;